import "./ContactSplash.css";
import emailjs from "emailjs-com";
import { useEffect, useState } from "react";

const Contact = () => {
  const [errors, setErrors] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const [show, setShow] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    if (errors.length > 0) {
      setShow(true);
      return;
    } else {
      console.log("sent");

      emailjs.sendForm('service_qo7ioim', 'template_ybhyw45', e.target, 'bVwjn2fVYUy3phcPs')
        .then((result) => {
          console.log(result.text);
        }, (error) => {
          console.log(error.text);
        });

      e.target.reset();
    }
  };

  useEffect(() => {
    let error = [];
    let regexEmail = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}", "i");
    let regexMessage = /\S/; // at least one non-whitespace character
    if (firstName.length < 1) error.push("Provide A Name");
    if (firstName.replace(/\s/g, "").length < 4) error.push("Provide a Name with 3 characters");
    // if(lastName.length < 1) error.push('Provide A Last Name')
    // if(lastName.replace(/\s/g, '').length < 1) error.push('Provide a Last Name')
    if (!regexEmail.test(email)) error.push("Provide A Valid Email");
    if (phoneNumber.length < 1) error.push("Provide A Phone Number");
    if (phoneNumber.length !== 10) error.push("Provide A Valid Phone Number");
    if (message.length < 10 || !regexMessage.test(message)) error.push("Provide A Message");

    setErrors(error);
  }, [firstName, email, phoneNumber, message]);
  return (
    <div className="SplashContact-Container">
      <div className="a-div">
        <h3 className="Contact-h3">Contact Us</h3>
        <div className="center-description">
          <div className="description-p-tag">
            Thank you for showing interest in our company. If you would like to
            contact us for any reason, please fill out the form to your right to
            get started on your free estimate!
          </div>
        </div>

        <span className="callNumber-tag">Or Call: 1(949) 412-3153</span>
      </div>
      {/* <div className="splash-form-container"> */}
      <div>
        {show
          ? errors.map((error, idx) => {
            return (
              <li key={idx} style={{ color: "red" }}>{error}</li>
            );
          })
          : null}
      </div>
      <form onSubmit={sendEmail} className="splash-form-container">
        <input
          className="splash-contact-input"
          onChange={(e) => {
            setFirstName(e.target.value);
          }}
          type="text"
          name="first_name"
          placeholder="Name"
          required
        />

        <input
          className="splash-contact-input"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          type="text"
          name="email"
          required
          placeholder="Email"
        />

        <input
          className="splash-contact-input"
          onChange={(e) => {
            setphoneNumber(e.target.value);
          }}
          type="number"
          name="phone"
          required
          placeholder="Phone Number"
        />

        <textarea
          className="splash-contact-input splash-textarea-input"
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          placeholder="Brief description of project..."
          type="text"
          name="message"
          required
        />

        <input
          className="splash-submit-button splash-curved-button"
          type="submit"
          value="Send Message"
        ></input>
      </form>
    </div>
  );
};

export default Contact;
